import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <Section data-id="element-90">
      <div className="bg-gradient-to-br from-brand-ice to-[#F8F5F0] p-6 md:p-12 rounded-2xl md:rounded-3xl border border-brand-slate-200 text-center max-w-2xl mx-auto" data-id="element-91">
        <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-brand-sky/10 flex items-center justify-center mx-auto mb-4 md:mb-6" data-id="element-92">
          <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-brand-sky" data-id="element-93" />
        </div>
        <h2 className="text-xl md:text-3xl font-bold text-brand-slate-900 mb-3 md:mb-4" data-id="element-94">
          Garantía de 7 días
        </h2>
        <p className="text-sm md:text-base text-brand-slate-600 leading-relaxed" data-id="element-95">
          Si el Sistema Freezer Fit no es para vos, te devolvemos el 100% de tu
          dinero. Sin preguntas, sin vueltas. Queremos que compres con total
          tranquilidad.
        </p>
      </div>
    </Section>;
}